export default __webpack_public_path__ + "static/media/docx.7733931f.svg";